import React from 'react'
import { SurfacePalette } from '../../../tokens'
import { useSectionNumber } from '../../PacketSectionsContext'
import { PresentPage } from '../PresentPage'
import { CreativeReviewHandoffCard } from '../../sections/CreativeReviewHandoffCard'

interface Props {
  palette: SurfacePalette
  businessID: number
  packetID: number
}

/**
 * Present-mode (dark) Creative slide: a link out to the review surface, which is
 * where the ads themselves live.
 *
 * The deck used to pace one theme per slide with an approve action on each card.
 * Packets now carry ~50 ads — more than a client works through in a meeting — so
 * they review on their own time and the meeting covers what they flagged.
 *
 * The creative strategy prose deliberately isn't repeated here. It opens the
 * review surface, which is the one place it's acted on; showing it in both left
 * the client reading the same paragraph twice on the way to the same place.
 *
 * No `section` comment anchor here: the slide no longer holds anything to comment
 * on, and the Edit-mode section keeps the anchor that existing threads point at.
 */
export const PresentCreativeSection = ({ palette, businessID, packetID }: Props) => {
  const number = useSectionNumber('creative')

  return (
    <PresentPage palette={palette} number={number} title="Creative">
      <CreativeReviewHandoffCard palette={palette} businessID={businessID} packetID={packetID} />
    </PresentPage>
  )
}
